import React, { useEffect } from 'react';
import WebSocket from '@services/WebSocket';
import { connect } from 'react-redux';
import { USER_ROLE } from '@config/app';
import { getCookie } from '@common/utils/cookie';
import { setTeam } from '@resources/Team/actions';
import { addClue, addClues } from '@resources/Clue/actions';
import { addPuzzle, addPuzzles } from '@resources/Puzzle/actions';
import { setSocket } from '@resources/Socket/actions';
import {
  addMember,
  removeMember,
  updateMember,
} from '@resources/Member/actions';
import { setUser } from '@resources/User/actions';
import { doAction } from '@resources/Action/actions';
import { notification } from 'antd';
import { updateSolve, fetchSolves, addSolve } from '@resources/Solve/actions';
import { setState } from '@resources/State/actions';
import { addStory, fetchStories } from '@resources/Story/actions';
import { addHelp, fetchHelps } from '@resources/Help/actions';
import { setEnd, fetchEnd } from '@resources/End/actions';

const Player = ({
  match,
  user,
  history,
  addMember,
  updateSolve,
  removeMember,
  setTeam,
  doAction,
  updateMember,
  setSocket,
  addHelp,
  setState,
  addSolve,
}) => {
  const { params } = match || {};
  const { channelId } = params || {};
  // const solvedPuzzles = getCookie('solved')
  // 	? JSON.parse(getCookie('solved'))
  // 	: [];

  useEffect(() => {
    const fetchData = async () => {
      // You can await here

      setTeam(channelId);
      // ...
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (!getCookie('THVuser')) {
      history.push(`/threevia/${channelId}/user`);
    }

    if (channelId && getCookie('THVuser')) {
      const u = JSON.parse(getCookie('THVuser'));
      let uid = null;
      let chan = null;
      if (u && u.name) {
        const { pusher, channel } = WebSocket({
          game: 'threevia',
          channel: channelId,
          name: u.name,
          role: USER_ROLE.PLAYER,
          onSubscribed: (member) => {
            uid = member.me.id;
            chan = channel;
            doAction({
              game: 'threevia',
              event: 'log',
              channel: chan,
              message: {
                id: uid,
                name: u.name,
                channel: channelId,
                location: 'lobby',
                message: 'has joined the game',
                game: 'threevia',
              },
            });
            for (var id in member.members) {
              const m = member.members[id];
              if (m.role === USER_ROLE.PLAYER) {
                if (id === uid) {
                  addMember({ id, name: u.name });
                } else {
                  addMember({ id, name: m.name });
                }
              }
            }
            setSocket({ id: uid, channel });
          },
          onMemberAdded: (member) => {
            if (member.info.role === USER_ROLE.PLAYER) {
              doAction({
                game: 'threevia',
                event: 'member',
                channel,
                message: { id: uid, name: u.name, game: 'threevia' },
              });
              addMember({
                id: member.id,
                name: member.info.name,
              });
            }
          },
          onMemberRemoved: (member) => {
            if (member.info.role === USER_ROLE.PLAYER) {
              removeMember(member);
            }
          },
          events: [
            {
              title: 'member',
              callback: (data) => {
                // console.log('SOCKET MEMBER', data);
                updateMember(data);
              },
            },
            {
              title: 'notification',
              callback: (notif) => {
                // console.log('SOCKET NOTIFICATION', notif);
                notification[notif.type]({
                  message: notif.title,
                  description: notif.description,
                });
              },
            },
            {
              title: 'solved',
              callback: (solve) => {
                // console.log('SOCKET SOLVED', solve);
                // const solved = getCookie('solved')
                //   ? JSON.parse(getCookie('solved'))
                //   : [];
                // setCookie(
                //   'solved',
                //   JSON.stringify(
                //     solved
                //       ? solved.filter((puzz) => puzz === solve).length > 0
                //         ? solved
                //         : [...solved, solve]
                //       : [solve]
                //   )
                // );

                if (solve.act === 'update' && solve.name === u.name) {
                  updateSolve(solve);
                }

                if (solve.act === 'create' && solve.name === u.name) {
                  addSolve(solve);
                }
              },
            },
            {
              title: 'state',
              callback: (state) => {
                // console.log('SOCKET HELP', help);
                setState(state);
              },
            },
            {
              title: 'help',
              callback: (help) => {
                // console.log('SOCKET HELP', help);
                addHelp(help.puzzle);
              },
            },
          ],
        });

        window.addEventListener('beforeunload', () => {
          doAction({
            game: 'threevia',
            event: 'log',
            channel,
            message: {
              id: uid,
              name: u.name,
              channel: channelId,
              location: 'lobby',
              message: 'has left the game',

              game: 'threevia',
            },
          });
          pusher.unsubscribe(channel);
        });
      }
    }
  }, [channelId, user, history]);

  return <div></div>;
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    clues: state.clues,
    helps: state.helps,
    solves: state.solves,
  };
};

export default connect(mapStateToProps, {
  addMember,
  addPuzzle,
  addPuzzles,
  removeMember,
  updateMember,
  setTeam,
  setUser,
  doAction,
  setSocket,
  addClue,
  addClues,
  fetchSolves,
  fetchHelps,
  updateSolve,
  addHelp,
  setEnd,
  fetchEnd,
  addStory,
  fetchStories,
  setState,
  addSolve,
})(Player);
